module.exports = __webpack_public_path__ + "img/add-image4.83f5ccb9.png";